import { render, staticRenderFns } from "./AreaSessionsForm.vue?vue&type=template&id=498c1f48&"
import script from "./AreaSessionsForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AreaSessionsForm.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports